export class OreiMatrix {
    constructor(socket, log) {
        this.socket = socket;
        this.power = true;
        this.videoOutputs = Array(17).fill('1');
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /r\s*fw\s*version!/i,
                callback: (match) => {
                    this.socket.send('V1.33');
                },
            },
            {
                name: 'getRoute',
                regExp: /r\s*out\s*(\d+)!/i,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    this.socket.send(`AV ${this.videoOutputs[output]} -> ${match[1]})`);
                },
            },
            {
                name: 'setRoute',
                regExp: /s\s*(\d+)\s*av\s*(\d+)!/i,
                callback: (match) => {
                    const output = parseInt(match[2], 10);
                    this.videoOutputs[output] = match[1];
                    this.socket.send(`AV ${this.videoOutputs[output]} -> ${match[1]})`);
                },
            },
            {
                name: 'powerSet',
                regExp: /s\s*power\s*(on|off)!/i,
                callback: (match) => {
                    this.power = match[1].toLowerCase() === 'on';
                    this.socket.send(`power ${this.power ? 'on' : 'off'}`);
                },
            },
            {
                name: 'powerQuery',
                regExp: /r\s*power!/i,
                callback: (match) => {
                    this.socket.send(`power ${this.power ? 'on' : 'off'}`);
                },
            },
        ];
    }
}
OreiMatrix.emulatorType = 'socketEmulator';
OreiMatrix.key = '-NwQHGCfejPDK32PmYBQ';
